import { ColorLogoPmo } from '@agora/icons'
import { useLocalStorageState } from 'ahooks'
import { useTitle } from 'ahooks'
import { useRequest } from 'ahooks'
import { Layout, Menu } from 'antd'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom'

import { departmentsAtom } from '@/modules/department'
import { okrCyclesAtom } from '@/modules/okr'
import { stagesAtom } from '@/modules/project/project-detail/project-stages/stages.atom'
import { usersAtom } from '@/modules/user'
import { routerConfig } from '@/router'
import { useAxiosWithAtom } from '@/utils'

export const AppContainer = () => {
  const { t, i18n } = useTranslation()
  if (i18n.resolvedLanguage === 'zh-CN') {
    i18n.changeLanguage('zh')
  }
  // 初始化项目依赖数据
  // const [viewer] = useAtom(userInfoAtom)
  const setUsers = useAtom(usersAtom)[1]
  const [departments, setDepartments] = useAtom(departmentsAtom)

  useRequest(
    { url: '/api/department/all' },
    {
      refreshOnWindowFocus: false,
      onSuccess(data) {
        ;(setUsers as any)(data.users)
        ;(setDepartments as any)(data.departments)
      },
    }
  )

  useAxiosWithAtom(okrCyclesAtom, { url: '/api/okr/getObjectiveCycles' })

  useAxiosWithAtom(stagesAtom, { url: '/api/project/getStages' })

  const location = useLocation()
  const [collapsed, setCollapsed] = useLocalStorageState('PMO_SIDEBAR_STATE', false)

  const routes = routerConfig.filter((c) => c.component)
  const currentRoute = routes.find((r) => location.pathname.startsWith(r.path)) || routes[0]!

  useTitle(currentRoute.title)

  const routeComponents = routes
    .map((c) => <Route key={c.title} path={c.path} component={c.component} />)
    .concat(<Redirect key='redirect' to={currentRoute.path} />)

  const logo = collapsed ? (
    <div className='flex h-12 m-2 items-center justify-center'>
      <ColorLogoPmo size={48} />
    </div>
  ) : (
    <div
      className='bg-contain bg-no-repeat h-12 m-2'
      style={{ backgroundImage: 'url(https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/pmo/logo-pmo.png)' }}
    />
  )

  const menu = (
    <Menu
      className='h-screen'
      theme='dark'
      mode='inline'
      selectedKeys={[currentRoute.title]}
      items={routerConfig.map((item) => ({
        key: item.title,
        icon: item.icon,
        label: <Link to={item.path}>{t(item.title)}</Link>,
      }))}
    ></Menu>
  )

  if (!departments.length) {
    return null
  }

  const siderWidth = collapsed ? 80 : 200

  return (
    <Layout>
      <Layout.Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(collapsed) => setCollapsed(collapsed)}
        className='z-1'
      >
        {logo}
        {menu}
      </Layout.Sider>
      <Layout style={{ marginLeft: siderWidth }}>
        <Layout.Content className={currentRoute.hasContainer ? '!min-h-screen px-8' : undefined}>
          <Switch>{routeComponents}</Switch>
        </Layout.Content>
      </Layout>
    </Layout>
  )
}
